import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/admin`;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } });
const data = (r) => r.data;

export const getEmployeeProfile = (id) => axios.get(`${API}/users/${id}/profile`, auth()).then(data);
export const saveEmployeeProfile = (id, body) => axios.put(`${API}/users/${id}/profile`, body, auth()).then(data);
export const uploadIdPhoto = (id, file) => {
  const fd = new FormData();
  fd.append("file", file);
  return axios.post(`${API}/users/${id}/id-photo`, fd, auth()).then(data);
};
export const getIdPhotoUrl = (id) =>
  axios.get(`${API}/users/${id}/id-photo`, { ...auth(), responseType: "blob" }).then((r) => URL.createObjectURL(r.data));

export const getEmployeeDocs = (id) => axios.get(`${API}/users/${id}/documents`, auth()).then(data);
export const uploadEmployeeDoc = (id, { file, doc_type, name, expiry }) => {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("doc_type", doc_type);
  fd.append("name", name || "");
  fd.append("expiry", expiry || "");
  return axios.post(`${API}/users/${id}/documents`, fd, auth()).then(data);
};
export const openEmployeeDoc = (id, docId) =>
  axios.get(`${API}/users/${id}/documents/${docId}`, { ...auth(), responseType: "blob" })
    .then((r) => window.open(URL.createObjectURL(r.data), "_blank"));
export const deleteEmployeeDoc = (id, docId) => axios.delete(`${API}/users/${id}/documents/${docId}`, auth()).then(data);

export const getEmployeeNotes = (id) => axios.get(`${API}/users/${id}/notes`, auth()).then(data);
export const addEmployeeNote = (id, text) => axios.post(`${API}/users/${id}/notes`, { text }, auth()).then(data);
export const deleteEmployeeNote = (id, noteId) => axios.delete(`${API}/users/${id}/notes/${noteId}`, auth()).then(data);

export const getEmployeeHistory = (id) => axios.get(`${API}/users/${id}/history`, auth()).then(data);

export const getCommissionGroups = () => axios.get(`${API}/commission-groups`, auth()).then(data);
export const createCommissionGroup = (body) => axios.post(`${API}/commission-groups`, body, auth()).then(data);
export const updateCommissionGroup = (id, body) => axios.put(`${API}/commission-groups/${id}`, body, auth()).then(data);
export const deleteCommissionGroup = (id) => axios.delete(`${API}/commission-groups/${id}`, auth()).then(data);
